import { useEffect, FC } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useAppThunkDispatch } from 'state/store';
import {
  teamBoard,
  teamBoardSearchParam,
  teamBoardProcess,
  teamBoardFilters,
  fetchProjects,
} from 'state/Projects/projectsSlice';
import { fetchFilterSettingByType } from 'state/Settings/Filters/FiltersSlice';
import { PROJECTS_BOARD_TABS, SETTINGS_FILTERS } from 'utils/constants';
import BoardHeader from './BoardHeader';
import EmptyBoard from './EmptyBoard';
import StagesList from './StagesList';

const TeamBoard: FC<{ handleAddProject: () => void }> = ({
  handleAddProject,
}) => {
  const dispatch = useAppThunkDispatch();
  const teamBoardStagesList = useSelector(teamBoard);
  const teamBoardSearch = useSelector(teamBoardSearchParam);
  const emptyTeamBoardFilters = isEmpty(useSelector(teamBoardFilters));
  const selectedProcessId = useSelector(teamBoardProcess);

  useEffect(() => {
    dispatch(fetchFilterSettingByType(SETTINGS_FILTERS.TEAM_PROJECTS_BOARD));
    dispatch(fetchProjects());
  }, [dispatch]);

  return (
    <div data-cy='team-board'>
      <BoardHeader
        boardTab={PROJECTS_BOARD_TABS.TEAM_BOARD}
        selectedProcessId={selectedProcessId}
        searchParam={teamBoardSearch}
      />
      <StagesList
        stages={teamBoardStagesList}
        areFiltersApplied={!emptyTeamBoardFilters}
        emptyComponent={
          <EmptyBoard
            handleAddProject={handleAddProject}
            isSearchEmpty={isEmpty(teamBoardSearch)}
            isFiltersEmpty={emptyTeamBoardFilters}
          />
        }
      />
    </div>
  );
};

export default TeamBoard;
